import { gql } from "apollo-boost";
import { fragments } from "../queries/User";

export default gql`
  mutation CreateUser($input: UserInput!) {
    createUser(input: $input) {
      ...UserQueryUser
    }
  }
  ${fragments.user}
`;



// WEBPACK FOOTER //
// ./src/mutations/CreateUser.js